<template>
    <b-modal id="modalEditDataAddUser" ref="modalEditDataAddUser" hide-footer @shown="load">
        <div v-if="userInfo.user_id">
            <b-form-group label-align="right" disabled label="ID :" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-model="userInfo.user_id" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Is provider free')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-checkbox switch size="lg" v-model="userInfo.is_provider_free" value="1" unchecked-value="0" />
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Is active')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-checkbox switch size="lg" v-model="userInfo.is_active" value="true" unchecked-value="false" />
            </b-form-group>
            <b-form-group disabled label-align="right" :label="$t('Name')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
                <b-form-input disabled type="text"  v-model="userInfo.full_name"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('First name')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
                <b-form-input type="text"  v-model="userInfo.first_name" :state="this.userInfo.first_name.length > 0"  aria-describedby="input-live-feedback"/>
                <b-form-invalid-feedback id="input-live-feedback">
                {{ $t('Must be non-empty') }}
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Last name')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
                <b-form-input type="text"  v-model="userInfo.last_name" :state="userInfo.last_name.length > 0"  aria-describedby="input-live-feedback"/>
                <b-form-invalid-feedback id="input-live-feedback">
                {{ $t('Must be non-empty') }}
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Mobile phone')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
                <b-form-input type="text"  v-model="userInfo.mobile_telephone" :state="userInfo.mobile_telephone.length > 0"  aria-describedby="input-live-feedback"/>
                <b-form-invalid-feedback id="input-live-feedback">
                {{ $t('Must be non-empty and be like 79008007060') }}
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Email')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
                <b-form-input type="text"  v-model="userInfo.email"/>
            </b-form-group>
        </div>
        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditDataAddUser')" size="md"/>
    </b-modal>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {

    }
  },
  methods: {
    async load () {
      await this.$store.dispatch('Users/GET_FULL_INFO_USERS', this.editItem.user_id)
    },
    sendUpdate () {
      this.$emit('update')
    },
    save () {
      let response = this.$store.dispatch('Settings/ADD_TV_24_USER', this.userInfo)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error.message, 'Error')
        } else {
          setTimeout(this.sendUpdate, 500)
          this.$root.$emit('makeToasts')
          this.$bvModal.hide('modalEditDataAddUser')
        }
      })
    }
  },
  computed: {
    userInfo () {
      let tmp = this.$store.getters['Users/FULL_INFO_USERS']
      this.$set(tmp, 'first_name', '')
      this.$set(tmp, 'last_name', '')
      if (!tmp.user_id) {
        tmp = {
          mobile_telephone: '',
          email: '',
          first_name: '',
          last_name: ''
        }
      } else {
        let splFullName = tmp.full_name.split(' ')
        tmp.last_name = splFullName[0]
        if (splFullName.length > 1) {
          tmp.first_name = splFullName[1]
        } else {
          tmp.first_name = ''
        }
      }
      tmp.is_provider_free = false
      tmp.is_active = true
      return tmp
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/24tv/modalAdd24TVUser.vue